import { render } from "./qidao.vue?vue&type=template&id=5adb0c2a"
import script from "./qidao.vue?vue&type=script&lang=js"
export * from "./qidao.vue?vue&type=script&lang=js"

import "./qidao.vue?vue&type=style&index=0&id=5adb0c2a&lang=scss"

import exportComponent from "/home/jenkins/workspace/xujiaxin-linchuang-pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__